import { Injectable} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { i18nPipe } from "../helper/i18n.pipes";
import { environment } from '../../../environments/environment';
import { BaseService } from './base.service';
import { DatePipe } from '@angular/common';

@Injectable()
export class StateService {
    language = "en_US";

    constructor(
        private activatedRoute:ActivatedRoute,
        private i18nPipe:i18nPipe,
        private meta: Meta,
        private title:Title,
        private datePipe:DatePipe,
        private baseService: BaseService
    ) {
        this.language = this.getLanguage();
    }

    getLanguage(){
        const urlParams = new URLSearchParams(window.location.search);
        
        if(urlParams.get('lang')){
            this.language = urlParams.get('lang');
        }
  
        console.log(this.language, urlParams.get('lang'));
        return this.language;
    }

    setLanguage(language){
        this.language = language;
    }

    sortOrderList(list, key, type = 'string') {
        list.sort((x, y) => {
            var xx;
            var yy;
            if (type == 'number') {
                xx = parseInt(x[key]);
                yy = parseInt(y[key]);
            } else {
                xx = x[key].toLowerCase();
                yy = y[key].toLowerCase();
            }

            if (xx > yy) return 1;
            if (xx < yy) return -1;
            return 0;
        })
        return list;
    }


    arrayToObject(arr){
        var output = [];
        for(var i=0; i<arr.length;i++){
            let value = arr[i];
            output.push({"id":value});
        };
        return output;
    }

    ObjectToArray(obj){
        var output = [];
        for(var i=0; i<obj.length;i++){
            let value = obj[i].id;
            output.push(value);
        };
        return output;
    }

    randomOrderList(list) {
        list.sort((x, y) => {
            var random = Math.floor((Math.random() * 10));
            if (random > 5) {
                return 1;
            } else {
                return -1;
            }
        })
        return list;
    }

    removeCustomMeta(){
        console.log(this.meta.getTag("viewport"));

        var metaList = this.meta.getTags("name");
        for(var i=0; i<metaList.length; i++){
            if(metaList[i]['name'] != "viewport"){
                var tag = "name='"+metaList[i]['name']+"'";
                this.meta.removeTag(tag);
            }
        }
    }

    setDefaultTitle(){
        this.title.setTitle("Sino");
    }
    
    getCookie(name: string) {  
        var nameEQ = name + "=";  
        var ca = document.cookie.split(';');
        console.log(ca);
        for (var i = 0; i < ca.length; i++) {  
            var c = ca[i];  
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);  
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);  
        }
        return null;
    }

    messageAlert(messageId){
        if(!messageId || this.i18nPipe.transform(messageId) == ""){
            alert(this.i18nPipe.transform('Unexpected error'));
        }else{
            if(messageId.indexOf('externalApiErr') >=0){
                const externalApiErr = messageId.replace("externalApiErr_","");
                alert(this.i18nPipe.transform('Unexpected error', externalApiErr))
            }else{
                alert(this.i18nPipe.transform(messageId));
            }
            
        }
        
    }

    getQueryParams(queryParams){
        let request = {};
        console.log(queryParams);
        if (queryParams['appId']) {
            request = Object.assign({ 'appId': queryParams['appId'] }, request);
        }
    }


    Now(format = "yyyy-MM-ddTHH:mm:ss"){
        let cDate = new Date();
        return this.datePipe.transform(cDate, format);
    }
}